module.exports = __webpack_public_path__ + "img/Bharain_logo.1b2ffdb0.png";